import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { selectUIComponent, formAddOnUIComponent } from 'ctm-css-themes';

/**
 * Simple Select component that renders passed options
 * @todo: This is just so we don't have to hook up with the schema bit, but we still had to import those UI components
 * @todo: We might have more stateSuffix we need to handle, so that brings some refactor to be done in this or the main Select component
 * @param {Object} props -  Select element props
 * @param {Array} props.options -  Array of option values to be built into elements
 * @param {Boolean} disabled - toggle component's disabled attr
 * @param {String} className - override the style from the parent component
 * @returns {Node} Returns Simple Select dropdown
 */
const SimpleSelect = ({ options = [], disabled, className, ...rest }) => {
    const stateSuffix = disabled ? '_disabled' : '';
    const componentClasses = className || selectUIComponent[`select_medium${stateSuffix}`];
    const addonClasses = classNames(formAddOnUIComponent[`addon${stateSuffix}`],
        formAddOnUIComponent.addon_suffix,
        formAddOnUIComponent.addon_width_default,
        formAddOnUIComponent.addon_suffix_menu);

    return (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label className={addonClasses}>
            <select className={componentClasses} {...rest}>
                {options.map(({ label, value }) => <option key={`${label}_${value}`} value={value}>{label}</option>)}
            </select>
        </label>
    );
};

SimpleSelect.propTypes = {
    options: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string
};

export { SimpleSelect };
